import { render, staticRenderFns } from "./team-custom-fields-popover.vue?vue&type=template&id=504fe6ea&"
import script from "./team-custom-fields-popover.vue?vue&type=script&lang=js&"
export * from "./team-custom-fields-popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports